import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    firebaseUid: null,
  },
  getters: {
    isLoggedIn: state => Boolean(state.firebaseUid),
    firebaseUid: state => state.firebaseUid
  },
  mutations: {
    SET_FIREBASE_UID(state, firebaseUid) {
      state.firebaseUid = firebaseUid
    }
  },
  actions: {
    login({ commit }, firebaseUid) {
      commit('SET_FIREBASE_UID', firebaseUid)
    },
    logout({ commit }) {
      commit('SET_FIREBASE_UID', null)
    }
  },
});
